import React, { useRef, useState, useEffect } from 'react';
import { Button } from './ui/button';

const FirmaDigital = ({ onFirmar, ancho = 400, alto = 180 }) => {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasFirma, setHasFirma] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#1e3a8a';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    // Dotted line at bottom
    ctx.setLineDash([4, 4]);
    ctx.beginPath();
    ctx.moveTo(20, alto - 20);
    ctx.lineTo(ancho - 20, alto - 20);
    ctx.strokeStyle = '#d1d5db';
    ctx.stroke();
    ctx.setLineDash([]);
    ctx.strokeStyle = '#1e3a8a';
  }, [ancho, alto]);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    if (e.touches) {
      return {
        x: (e.touches[0].clientX - rect.left) * scaleX,
        y: (e.touches[0].clientY - rect.top) * scaleY
      };
    }
    return {
      x: (e.clientX - rect.left) * scaleX,
      y: (e.clientY - rect.top) * scaleY
    };
  };

  const startDraw = (e) => {
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const pos = getPos(e);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
    setDrawing(true);
    setHasFirma(true);
  };

  const draw = (e) => {
    e.preventDefault();
    if (!drawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const pos = getPos(e);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
  };

  const stopDraw = (e) => {
    e?.preventDefault();
    setDrawing(false);
  };

  const limpiar = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#1e3a8a';
    ctx.lineWidth = 2;
    ctx.setLineDash([4, 4]);
    ctx.beginPath();
    ctx.moveTo(20, alto - 20);
    ctx.lineTo(ancho - 20, alto - 20);
    ctx.strokeStyle = '#d1d5db';
    ctx.stroke();
    ctx.setLineDash([]);
    ctx.strokeStyle = '#1e3a8a';
    setHasFirma(false);
  };

  const confirmar = () => {
    if (!hasFirma) return;
    const canvas = canvasRef.current;
    const base64 = canvas.toDataURL('image/png');
    onFirmar(base64);
  };

  return (
    <div className="space-y-3" data-testid="firma-digital-container">
      <p className="text-sm text-gray-600 font-medium">Firma con el dedo o mouse:</p>
      <div className="border-2 border-dashed border-blue-300 rounded-xl overflow-hidden bg-white inline-block">
        <canvas
          ref={canvasRef}
          width={ancho}
          height={alto}
          className="touch-none cursor-crosshair w-full max-w-[400px]"
          onMouseDown={startDraw}
          onMouseMove={draw}
          onMouseUp={stopDraw}
          onMouseLeave={stopDraw}
          onTouchStart={startDraw}
          onTouchMove={draw}
          onTouchEnd={stopDraw}
          data-testid="firma-canvas"
        />
      </div>
      <div className="flex gap-3">
        <Button variant="outline" size="sm" onClick={limpiar} type="button" data-testid="firma-limpiar-btn">
          <i className="fas fa-eraser mr-2" />Limpiar
        </Button>
        <Button
          size="sm"
          onClick={confirmar}
          disabled={!hasFirma}
          className="bg-blue-600 hover:bg-blue-700"
          type="button"
          data-testid="firma-confirmar-btn"
        >
          <i className="fas fa-check mr-2" />Confirmar Firma
        </Button>
      </div>
    </div>
  );
};

export default FirmaDigital;
